<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover">
            <template slot="header">
              <h4 class="card-title">Filter</h4>
              <div class="row">
                <div style="margin-left: 20px; margin-bottom: 20px">
                  <label for="startDate">Start Date</label>
                  <datepicker :readonly="true"
                              format="yyyy-MM-dd"
                              id="startDate"
                              name="start-date"
                              v-model="filterFrom"></datepicker>
                </div>
                <div style="margin-left: 20px; margin-bottom: 20px">
                  <label for="endDate">End Date</label>
                  <datepicker :readonly="true"
                              id="endDate"
                              format="yyyy-MM-dd"
                              name="end-date"
                              v-model="filterTo"></datepicker>
                </div>
                <div style="margin-left: 20px; margin-bottom: 20px">
                  <button class="btn btn-info btn-fill" v-on:click="filterData()">Filter
                  </button>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <tabs :options="{ useUrlFragment: false }" @clicked="tabClicked" @changed="tabChanged">
            <tab name="Weather chart">
              <div id="chartWeather">
              </div>
            </tab>
            <tab name="Wind chart">
              <div id="chartWind">
              </div>
              <div id="chartWind2">
              </div>
            </tab>
            <tab name="Wind rose">
              <div id="chartWindRose">
              </div>
              <div id="chartWindRose2">
              </div>
            </tab>
            <tab name="Wind grouped percent chart">
              <div id="chartWindGroupedPercent">
              </div>
            </tab>
            <tab name="Wind grouped chart">
              <div id="chartWindGrouped">
              </div>
            </tab>
            <tab name="Power chart">
              <div id="chartPower">
              </div>
            </tab>
          </tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="https://code.highcharts.com/highcharts.js"></script>
<script src="https://code.highcharts.com/highcharts-more.js"></script>
<script src="https://code.highcharts.com/modules/data.js"></script>
<script src="https://code.highcharts.com/modules/windbarb.js"></script>
<script src="https://code.highcharts.com/modules/datagrouping.js"></script>
<script src="https://code.highcharts.com/modules/exporting.js"></script>
<script src="https://code.highcharts.com/modules/export-data.js"></script>
<script src="https://code.highcharts.com/modules/accessibility.js"></script>
<script>

  import Card from 'src/components/Cards/Card.vue'
  import ApexCharts from 'apexcharts'
  import Highcharts from 'highcharts'
  import HighchartsMore from 'highcharts/highcharts-more'
  import Datepicker from 'vuejs-datepicker';
  import {encodeData} from "../../tools/UrlTools";
  import EventBus from "../../event-bus";
  import moment from 'moment-timezone';

  const Vue = window.Vue;

  HighchartsMore(Highcharts);
  require('highcharts/modules/windbarb')(Highcharts);
  require('highcharts/modules/data')(Highcharts);
  require('highcharts/modules/datagrouping')(Highcharts);
  require('highcharts/modules/exporting')(Highcharts);
  require('highcharts/modules/export-data')(Highcharts);
  require('highcharts/modules/accessibility')(Highcharts);
  require('highcharts/highcharts-more')(Highcharts);

  function hexToRGB(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);
  
    if (alpha) {
     return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
  }

  export default {
    name: "DeviceChartsPage",
    components: {
      Card,
      ApexCharts,
      Datepicker
    },
    data() {
      return {
        filterFrom: moment().tz("Europe/Warsaw").format('YYYY-MM-DD'),
        filterTo: moment().tz("Europe/Warsaw").format('YYYY-MM-DD'),
        device: null,
        chartData: {
          height: 600,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: true
          }
        },
        chartDataBar: {
          height: 600,
          type: 'bar',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
          toolbar: {
            show: true
          }
        },
        xaxisData: {
          categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
          title: {
            text: 'Timestamp'
          }
        },
        colorsData: ['#77B6EA', '#545454', '#AB4433', '#00FF00', '#FFD700', '#FF4500'],
        dataLabelsData: {
          enabled: false,
        },
        strokeData: {
          curve: 'smooth'
        },
        gridData: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        markersData: {
          size: 0.3
        },
        legendData: {
          position: 'top',
          horizontalAlign: 'center',
          floating: true,
          offsetY: -25,
          offsetX: -5,
          show: true,
          showForSingleSeries: true,
        },
        yaxisData: {
          title: {
            text: 'Temperature'
          },
          min: 5,
          max: 40
        },
      }
    },
    mounted() {
      this.loadDevice();
    },

    methods: {
      loadDevice() {
        let url = 'device/' + this.$route.params.deviceId;

        if (this.$route.params.localizationHistoryId !== undefined) {
          url += '?localizationHistoryId=' + this.$route.params.localizationHistoryId;
        }

        this.$http.get(url)
          .then(result => {
            this.device = result.data;

            this.filterFrom = this.device.lastDataDate.slice(0, 10);
            this.filterTo = this.device.lastDataDate.slice(0, 10);

            EventBus.$emit('EVENT_PATHS', [["/#/devices/list", 'Devices'],
              ['/#/devices/details/' + this.$route.params.deviceId, this.device.name],
              ['/#/devices/charts/' + this.$route.params.deviceId, 'Charts']]);

            this.loadData(this.device.serial);
            this.loadWindGrouped(this.device.serial);
            this.loadWindRose(this.device.serial);
          }, error => {
            console.error(error);
          });
      },
      loadData(serial) {
        let url = 'data/chart/' + serial;

        if (this.$route.params.localizationHistoryId !== undefined) {
          url += '/' + this.$route.params.localizationHistoryId;
        }

        let params = {};
        if (this.filterFrom !== null && this.filterFrom) {
          if (typeof this.filterFrom == 'string')
            params['from'] = this.filterFrom;
          else
            params['from'] = this.filterFrom.toISOString().slice(0, 10);
        }
        if (this.filterTo !== null && this.filterTo) {
          if (typeof this.filterTo == 'string')
            params['to'] = this.filterTo;
          else
            params['to'] = this.filterTo.toISOString().slice(0, 10);
        }

        if (Object.keys(params).length)
          url += '?' + encodeData(params);

        this.$http.get(url)
          .then(result => {
            // this.showChart(result.data);
            let times = [];

            for (let x = 0; x < result.data.timestamp.length; x++) {
              // times.push(new Date(data.timestamp[x]))
              times.push(moment(result.data.timestamp[x]).tz("Europe/Warsaw").format('YY-MM-DD HH:mm'))
            }

            this.showChartWeather(result.data, times);
            this.showChartWind(result.data, times);
            this.showChartPower(result.data, times );
          }, error => {
            console.error(error);
          });
      },
      loadWindGrouped(serial) {
        let url = 'data/chart/wind/grouped/' + serial;

        let params = {};
        if (this.filterFrom !== null && this.filterFrom) {
          if (typeof this.filterFrom == 'string')
            params['from'] = this.filterFrom;
          else
            params['from'] = this.filterFrom.toISOString().slice(0, 10);
        }
        if (this.filterTo !== null && this.filterTo) {
          if (typeof this.filterTo == 'string')
            params['to'] = this.filterTo;
          else
            params['to'] = this.filterTo.toISOString().slice(0, 10);
        }

        if (Object.keys(params).length)
          url += '?' + encodeData(params);

        this.$http.get(url)
          .then(result => {
            this.showChartWindGrouped(result.data);
            this.showChartWindGroupedPercent(result.data);
          }, error => {
            console.error(error);
          });
      },
      loadWindRose(serial) {
        let url = 'data/chart/wind/rose/' + serial;

        let params = {};
        if (this.filterFrom !== null && this.filterFrom) {
          if (typeof this.filterFrom == 'string')
            params['from'] = this.filterFrom;
          else
            params['from'] = this.filterFrom.toISOString().slice(0, 10);
        }
        if (this.filterTo !== null && this.filterTo) {
          if (typeof this.filterTo == 'string')
            params['to'] = this.filterTo;
          else
            params['to'] = this.filterTo.toISOString().slice(0, 10);
        }

        if (Object.keys(params).length)
          url += '?' + encodeData(params);

        this.$http.get(url)
          .then(result => {
            this.showChartWindRose(result.data);
          }, error => {
            console.error(error);
          });
      },
      showChartWeather(data, times) {
        let options = {
          title: {
            text: 'Data parameters',
            align: 'left'
          },
          chart: this.chartData,
          series: [
            {
              name: "Temp. outside BME [°C]",
              data: data.temperature1
            },
            {
              name: "Temp. outside DS [°C]",
              data: data.temperature3
            },
            {
              name: "Humidity [%]",
              data: data.humidity
            },
            {
              name: "Pressure [hPa]",
              data: data.pressure
            },
            {
              name: "Light [klux]",
              data: data.light
            },
          ],
          colors: this.colorsData,
          dataLabels: this.dataLabelsData,
          stroke: this.strokeData,
          grid: this.gridData,
          markers: this.markersData,
          legend: this.legendData,
          labels: times,
          xaxis: {
            labels: {
              show: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
            }
          }
          // xaxis: {
          //   type: 'datetime',
          // },
        };

        var chart = new ApexCharts(document.querySelector("#chartWeather"), options);

        chart.render();
      },
      showChartWind(data, times) {
        let x = times.map(function(x) { return Date.parse('20'+(x.replace(' ', 'T'))); });
        let speed = data.windSpeed1;
        let dir = data.windDirection1.map(function(x) { return x - 180 });
        let combined = speed.map((e, i) => [x[i], e, dir[i]]);
        //console.log('DEBUG windbarb');
        //console.log(times);
        //console.log(x);
        //console.log(combined);
        let options = {
          chart: {
            renderTo: 'chartWind',
            type: 'windbarb',
          },
          title: {
            text: 'Data parameters',
            align: 'left'
          },
          xAxis: {
            type: 'datetime',
            offset: 40,
            data: x
          },
          yAxis: {
            title: {
              text: 'Wind Speed [m/s]'
            }
          },
          series: [{
            data: combined,
            name: 'Wind',
            color: this.colorsData[0],
            showInLegend: false,
            tooltip: {
              valueSuffix: ' m/s'
            }
          }, {
            type: 'area',
            keys: ['x', 'y'], // wind direction is not used here
            data: combined,
            color: this.colorsData[0],
            fillColor: {
              linearGradient: {x1: 0, x2: 0, y1: 0, y2: 1},
              stops: [
                [0, this.colorsData[0]],
                [1, hexToRGB(this.colorsData[0], 0.25)]
              ]
            },
            name: 'Wind speed',
            tooltip: {
              valueSuffix: ' m/s'
            },
            states: {
              inactive: {
                opacity: 1
              }
            }
          }]
        }

        //console.log(options)

        var chart = new Highcharts.Chart(options);

        let isAdmin = localStorage.getItem('isAdmin') === 'true';
        if (isAdmin) {
          let speed2 = data.windSpeed2;
          let dir2 = data.windDirection2.map(function(x) { return x - 180 });
          let combined2 = speed2.map((e, i) => [x[i], e, dir2[i]]);
          var options2 = options;
          options2.series[0].data = combined2;
          options2.series[1].data = combined2;
          options2.chart.renderTo = 'chartWind2';
          var chart2 = new Highcharts.Chart(options2);
        }

      },
      showChartWindRose(data) {
        var data1 = []
        var data2 = []
        let dir = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW']
        
        let legend = ["Direction", "< 0.5 m/s", "0.5 - 2 m/s", "2 - 4 m/s", "4 - 6 m/s", "6 - 8 m/s", "8 - 10 m/s", "> 10 m/s"]
        
        data1.push(legend)
        for (var i in data.wind1) {
          data1.push(
            [dir[i]].concat(data.wind1[i])
          )
        }
        data2.push(legend)
        for (var i in data.wind2) {
          data2.push(
            [dir[i]].concat(data.wind2[i])
          )
        }
        console.log(data1)
        let options = {
          chart: {
            renderTo: 'chartWindRose',
            polar: true,
            type: 'column',
          },
          title: {
            text: 'Data parameters',
            align: 'left'
          },
          legend: {
            align: 'right',
            verticalAlign: 'top',
            y: 100,
            layout: 'vertical'
          },
          xAxis: {
            tickmarkPlacement: 'on'
          },
          yAxis: {
            min: 0,
            endOnTick: false,
            showLastLabel: true,
            title: {
              text: 'Wind Frequency'
            },
            labels: {
              format: '{value}%'
            },
            reversedStacks: false
          },
          plotOptions: {
            series: {
              stacking: 'normal',
              shadow: false,
              groupPadding: 0,
              pointPlacement: 'on',
              tooltip: {
                valueSuffix: '%'
              }
            }
          },
          data: {
            rows: data1
          }
        }

        //console.log(options)

        var chart = new Highcharts.Chart(options);

        let isAdmin = localStorage.getItem('isAdmin') === 'true';
        if (isAdmin) {
          var options2 = options;
          options2.data.rows = data2;
          options2.chart.renderTo = 'chartWindRose2';
          var chart2 = new Highcharts.Chart(options2);
        }
      },
      showChartWindGrouped(data) {
        let options = {
          title: {
            text: 'Data parameters',
            align: 'left'
          },
          chart: this.chartDataBar,
          series: [
            {
              name: "Wind Speed 1 [count]",
              data: data.wind1
            },
            // {
            //   name: "Wind Speed 2 [count]",
            //   data: data.wind2
            // },
          ],
          xaxis: {
            categories: ['0 m/s', '1 m/s', '2 m/s', '3 m/s', '4 m/s', '5 m/s', '6 m/s', '7 m/s', '8 m/s', '9 m/s',
              '10 m/s', '11 m/s', '12 m/s', '13 m/s', '14 m/s', '15 m/s', '16 m/s',
              '17 m/s', '18 m/s', '19 m/s', '20 m/s', '21 m/s', '22 m/s', '23 m/s', '24 m/s',
              '25 m/s', '26 m/s', '27 m/s', '28 m/s', '29 m/s', '30 m/s'],
          },
          // yaxis: this.yaxisData,
          colors: this.colorsData,
          dataLabels: this.dataLabelsData,
          stroke: this.strokeData,
          grid: this.gridData,
          markers: this.markersData,
          legend: this.legendData
        };
        var chart = new ApexCharts(document.querySelector("#chartWindGrouped"), options);

        chart.render();
      },
      showChartWindGroupedPercent(data) {
        let options = {
          title: {
            text: 'Data parameters',
            align: 'left'
          },
          chart: this.chartDataBar,
          series: [
            {
              name: "Wind Speed 1 [%]",
              data: data.wind1Percent
            },
            // {
            //   name: "Wind Speed 2 [%]",
            //   data: data.wind2Percent
            // },
          ],
          xaxis: {
            categories: ['0 m/s', '1 m/s', '2 m/s', '3 m/s', '4 m/s', '5 m/s', '6 m/s', '7 m/s', '8 m/s', '9 m/s',
              '10 m/s', '11 m/s', '12 m/s', '13 m/s', '14 m/s', '15 m/s', '16 m/s',
              '17 m/s', '18 m/s', '19 m/s', '20 m/s', '21 m/s', '22 m/s', '23 m/s', '24 m/s',
              '25 m/s', '26 m/s', '27 m/s', '28 m/s', '29 m/s', '30 m/s'],
          },
          // yaxis: this.yaxisData,
          colors: this.colorsData,
          dataLabels: this.dataLabelsData,
          stroke: this.strokeData,
          grid: this.gridData,
          markers: this.markersData,
          legend: this.legendData
        };
        var chart = new ApexCharts(document.querySelector("#chartWindGroupedPercent"), options);

        chart.render();
      },
      showChartPower(data, times) {
        let options = {
          title: {
            text: 'Data parameters',
            align: 'left'
          },
          chart: this.chartData,
          series: [
            {
              name: "Battery [V]",
              data: data.battery
            },
            {
              name: "Panel [V]",
              data: data.panel
            },
            {
              name: "Light [klux]",
              data: data.light
            },
          ],
          colors: this.colorsData,
          dataLabels: this.dataLabelsData,
          stroke: this.strokeData,
          grid: this.gridData,
          markers: this.markersData,
          legend: this.legendData,
          labels: times,
          xaxis: {
            labels: {
              show: true,
              hideOverlappingLabels: true,
              showDuplicates: false,
            }
          }
        };

        var chart = new ApexCharts(document.querySelector("#chartPower"), options);

        chart.render();
      },
      filterData() {
        this.loadData(this.device.serial);
        this.loadWindGrouped(this.device.serial);
        this.loadWindRose(this.device.serial);
      }
    }
  }
</script>
<style>
  .content {
    width: 100%;
    background: #f8f9fa;
  }

  .card-plain {
    margin-bottom: inherit;
  }

  .table-responsive {
    background: whitesmoke;
    border-color: #0e0e0e;
  }

  .card-body {
    background: #f8f9fa;
  }

  .cardPlain {
    margin: 10px;
    margin-top: 20px;
    background-color: #e5e5e5;
  }

  h5 {
    background: #E3E3E3;
  }

  .headStyle {
    background: cadetblue;
  }

  .filterDate {
    margin-bottom: 60px;

  }
</style>
